import React, { useContext } from "react";
import "./SlotGameInfoPageStyle.scss";
import { slotGamesInfoTextContent } from "./constant/index";
import MainLayout from "../../components/MainLayout";
import GameDetailsListSection from "../../components/GameDetailsListSection";
import AboutGameSection from "../../components/AboutGameSection";
import SlotGamesSection from "../../components/SlotGamesSection";
import ContactUsSection from "../../components/ContactUsSection";
import CustomButton from "../../components/Common_UI_Kit/CustomButton";
import { useLocation, useNavigate } from "react-router-dom";
import { convertToCamelCase } from "util";
import { LoginContext } from "context/context";

const SlotGameInfoPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { loginData, setOpenLoginModal } = useContext(LoginContext) 

  const handleButtonClick = () => {
    if (loginData) navigate(`/slot-game-play`, {state: location.state})
    else setOpenLoginModal(true)
  }
  const imgName = convertToCamelCase(location.state.name)
  const img = `/assets/images/slot/cover/${imgName}.png`
  const slotGameInfoTextContent = slotGamesInfoTextContent[location.state.launchUrl]

  return (
    <MainLayout>
      <div className="slot-game-info-page">
        <div className="game-details-section">
          <div className="game-details-wrap">
            <div className="game-img-wrap">
              <div className="game-img-box">
                <img src={img || slotGameInfoTextContent.imgSrcGame} alt="Image" />
              </div>
              
              <div className="btn-box">
                <CustomButton buttonType="primary" label={slotGameInfoTextContent.btnText} onClick={handleButtonClick} />
              </div>
            </div>

            <GameDetailsListSection
              gameDetailsList={slotGameInfoTextContent.gameDetailsList}
            />
          </div>
        </div>

        <AboutGameSection
          paragraphText={slotGameInfoTextContent.paragraphText}
          listItemTitle={slotGameInfoTextContent.listItemTitle}
          listText={slotGameInfoTextContent.listText}
        />

        {/* <SlotGamesSection
          sectionHeadingText={slotGameInfoTextContent.headingText}
        /> */}

        {/* <ContactUsSection /> */}
      </div>
    </MainLayout>
  );
};

export default SlotGameInfoPage;
